module.exports = __webpack_public_path__ + "assets/img/404_24h.e673fbe2.svg";